
import React, { memo, useMemo } from 'react';
import { project } from '../utils/isometricMath';
import { GRID_SIZE } from '../constants';

interface IsometricGridProps {
  rotation: { x: number, y: number };
  zLevel?: number;
}

export const IsometricGrid: React.FC<IsometricGridProps> = memo(({ rotation, zLevel = 0 }) => {
  const gridPath = useMemo(() => {
    let pathData = "";
    const ext = GRID_SIZE / 2;
    // Dibujamos una malla de puntos en el suelo (Plano XZ)
    for (let x = -ext; x <= ext; x++) {
      for (let z = -ext; z <= ext; z++) {
        const p = project({ x, y: 0, z }, rotation);
        pathData += `M ${p.x},${p.y} l 0,0 `;
      }
    }
    return pathData;
  }, [rotation]);

  return (
    <path 
      d={gridPath}
      stroke="#cbd5e1"
      strokeWidth="3"
      strokeLinecap="round"
      fill="none"
      className="transition-colors duration-500"
      style={{ pointerEvents: 'none' }}
    />
  );
});
